import Clipboard from 'clipboard';

import $ from '@rover/globals/jquery';
import Rover from '@rover/globals/Rover';

export { capitalizeFirstLetter } from './capitalizeFirstLetter';

Rover.utils = Rover.utils || {};
Rover.utils.strings = Rover.utils.strings || {};

export const possessive = (str: string): string => {
  if (str.slice(-1).toLowerCase() === 's') {
    return `${str}'`;
  }

  return `${str}'s`;
};

Rover.utils.simpleSyndeticJoin = (arr) => arr.join(', ');

Rover.utils.getCsrfToken = () => {
  let csrfCookieName;
  const $meta = $('meta[name=csrf-cookie-name]');

  if ($meta.length > 0) {
    csrfCookieName = $meta.attr('content');
  } else {
    csrfCookieName = 'csrftoken';
  }

  return $.cookie(csrfCookieName);
};

type Selector = string | Element | NodeListOf<Element>;

export const copyTextToClipboard = (
  triggerSelector: Selector,
  successCallback: (e: Clipboard.Event) => void
): void => {
  let callbackForSuccess = successCallback;
  if (typeof successCallback !== 'function') callbackForSuccess = () => {};
  const board = new Clipboard(triggerSelector);
  board.on('success', callbackForSuccess);
  board.on('error', () => {});
};

const exportedString = {
  possessive,
  copyTextToClipboard,
};

export default exportedString;
